<style scoped>
    .text-remark {
        margin: 0px;
    }
</style>
<template>
  <div class="text-center d-flex align-center justify-space-around">
    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          
          v-bind="attrs"
          v-on="on"
        >
          mdi-help-circle-outline
        </v-icon>
      </template>
      <p class="text-remark">
        请补充以下信息，方便我们了解更多内容哦：
      </p>
      <p class="text-remark">
        派单内容：例如：完成3篇剧本，用于“柚子鸭主题营”的内容设计。或：交付100张插画，作为“哈利波特”的素材
      </p>
      <p class="text-remark">
        派单时间：例如：2021年1月1日
      </p>
      <p class="text-remark">
        计价方式：例如：按次结算，每次100元。或：按稿件结算，每交付一张合格的插画，支付100元
      </p>
      <p class="text-remark">
        实际交付时间：例如：2021年10月10日
      </p>
      <p class="text-remark">
        实际交付的工作产出：例如：按照要求只提供了50张插画，质量过关。
      </p>
    </v-tooltip>
  </div>
</template>
<script>
  export default {

  }
</script>
